import React, { useState } from "react";
import { useCallback } from "react";
import EditMerchant from "./step-one";
import EditFinalStep from "./step-two";

export const EditMerchantForm = () => {
  const [formStep, setFormStep] = useState(1);

  const goToNext = useCallback(() => setFormStep(formStep + 1), [formStep]);
  const goToPrev = useCallback(() => setFormStep(formStep - 1), [formStep]);

  return (
    <>
      {formStep === 1 && <EditMerchant nextStep={goToNext} />}
      {formStep === 2 && <EditFinalStep prevStep={goToPrev} />}
    </>
  );
};

export default EditMerchantForm;
